import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface User {
  email: string;
  role: 'admin' | 'superadmin';
  name: string;
}

interface AuthState {
  user: User | null;
  token: string | null;
}

const initialState: AuthState = {
  user: null,
  token: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<{ user: User; token: string }>) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      localStorage.setItem('authToken', action.payload.token);
      localStorage.setItem('userEmail', action.payload.user.email);
      localStorage.setItem('userRole', action.payload.user.role);
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      localStorage.removeItem('authToken');
      localStorage.removeItem('userEmail');
      localStorage.removeItem('userRole');
      localStorage.removeItem('isAuthenticated');
    },
    restoreAuth: (state) => {
      const token = localStorage.getItem('authToken');
      const email = localStorage.getItem('userEmail');
      const role = localStorage.getItem('userRole');
      if (token && email && role) {
        state.token = token;
        state.user = {
          email,
          role: role as 'admin' | 'superadmin',
          name: email.split('@')[0],
        };
      }
    },
  },
});

export const { login, logout, restoreAuth } = authSlice.actions;
export default authSlice.reducer;